import { CtInvoice } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model =  {
    id: {
      field: 'id',
      label: 'id',
      validator: () => true,
      type: 'string',
      required: true
    },
    name: {
      field: 'name',
      label: 'Name',
      validator: () => true,
      type: 'string',
      required: false
    },
    timerange_start: {
      field: 'timerange_start',
      label: 'From Date',
      validator: () => true,
      // readonly: true,
      type: 'string',
      required: false
    },
    timerange_end: {
      field: 'timerange_end',
      label: 'To Date',
      validator: () => true,
      // readonly: true,
      type: 'string',
      required: false
    },
    items: {
      field: 'items',
      label: 'Items',
      validator: () => true,
      readonly: true,
      type: 'json',
      required: false
    },
    orders: {
      field: 'orders',
      label: 'Order References',
      validator: () => true,
      readonly: true,
      type: 'array',
      required: false
    },
    headers: {
      field: 'headers',
      label: 'Headers',
      validator: () => true,
      type: 'json',
      required: false
    },
    reset: {
      field: 'reset',
      label: 'Is Reset?',
      validator: () => true,
      readonly: true,
      type: 'boolean',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtInvoice>(
  ContentType.Invoice, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
